// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5006":"410a9f561e593851","8271":"53e2a3b31477ca62"}[chunkId] + ".css";
};